module.exports = __webpack_public_path__ + "img/4_4.e692f7a7.png";